import { render, staticRenderFns } from "./Policyitems-details.vue?vue&type=template&id=4631b670&scoped=true&"
import script from "./Policyitems-details.vue?vue&type=script&lang=js&"
export * from "./Policyitems-details.vue?vue&type=script&lang=js&"
import style0 from "./Policyitems-details.vue?vue&type=style&index=0&id=4631b670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4631b670",
  null
  
)

export default component.exports